import API from "../helpers/api";
import {TQuote} from "../helpers/types";

export const getAllQuotes = () => API.get('/quotes').then((response:any): TQuote[] => response.data.data)
export const getQuoteById = (id?: string) => API.get(`/quotes/${id}`).then((response:any): TQuote => response.data);
export const updateQuote = (id: string, updatedData: TQuote) => API.put(`/quotes/${id}`, updatedData).then((response:any): TQuote => response.data)
export const updateQuoteStatus = (id: string, status: boolean) => API.put(`/quotes/${id}/status`, {status}).then((response:any): TQuote => response.data)
